export default __webpack_public_path__ + "static/media/loop-graph.12d68da6.svg";